import { Link } from 'gatsby'
import React, { useState } from 'react'
import BurgerMenu from './BurgerMenu'
import ClinicFinder from './ClinicFinder'
import './SectionHeaderMobile.scss'

const SectionHeaderMobile = () => {
  const [showFindClinic, setShowFindClinic] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  const modalClass = showFindClinic ? "visible": "";

  return (
    <div className='SectionHeaderMobile'>
      <div className={`modal ${modalClass}`}>
        <ClinicFinder modal={true} setCloseModal={() => setShowFindClinic(false)}/>
        <div className="overlay" 
          role="button" 
          tabIndex="0" 
          aria-label="Dismiss clinic finder"
          onKeyPress={() => setShowFindClinic(false)}
          onClick={() => setShowFindClinic(false)}/>
      </div>
      <div className="top-row">
        <div className="left">
          <Link to="/"><img src="/assets/logo.svg" alt="logo"/></Link>
        </div>
        <div className="right">
          <div className="buttons">
            <button onClick={() => setShowSearch(true)}><img src="/assets/tmp_search.svg" alt="search" /></button>
            <button onClick={() => setShowFindClinic(true)}><img src="/assets/tmp_map_pin.svg" alt="search" /></button>
          </div>
          <BurgerMenu isOpen={showSearch} setIsOpen={setShowSearch}/>
        </div>
      </div>
    </div>
  )
}

export default SectionHeaderMobile